import { Dayjs } from 'dayjs'
import React, { useContext } from 'react'

import SelectStartDateStep from '@/pages/create-consultation/components/SelectStartDateStep'

import { CreateConsultationStepperContext } from '../CreateConsultationStepper'

export function SelectStartDateStepContainer({ currentDateTime }: { currentDateTime: Dayjs }) {
  const { setValue, values } = useContext(CreateConsultationStepperContext)

  const handleSelectStartDate = (startDate: string | null, error?: string | null) => {
    setValue('startDate', !!error || !startDate ? undefined : startDate)
  }

  return (
    <SelectStartDateStep
      currentDateTime={currentDateTime}
      defaultStartDate={values.startDate ? new Date(values.startDate) : undefined}
      onSelect={handleSelectStartDate}
    />
  )
}

export default SelectStartDateStepContainer
